  <!-- 我的足迹 -->
  <template>
  <div class="foot-print-page" v-cloak>
    <van-nav-bar left-arrow fixed title="我的足迹" id="nav-bar" @click-left="onClickLeft">
      <!-- <template #right>
         @click-right="onClickRight"
        <span v-if="productList.length > 0 && isEdit == true">编辑</span>
        <span v-if="productList.length > 0 && isEdit == false">完成</span>
      </template> -->
    </van-nav-bar>
    <!-- 列表 -->

    <div class="list">
      <van-list v-model="loading" :immediate-check="true" :finished="finished" finished-text="没有更多了" @load="getInit">

        <div v-for="(itm, inx) in productList" :key="inx">
          <p class="time-tips">{{ itm.date }}</p>
          <div class="img-text-row" @click="setType(index, item)" v-for="(item, index) in itm.goods" :key="index">
            <div class="radio" v-if="isEdit == false">
              <img :src="item.checked? radio_active_icon : radio_icon" />
            </div>

            <div class="row-goods-img">
              <img :src="item.pic" alt="" />
            </div>

            <div class="row-goods-info">
              <p class="row-goods-name van-multi-ellipsis--l2">{{ item.goods_name }}</p>
              <!-- <p class="row-goods-des">{{ item.description }}</p> -->

              <!-- <p class="row-goods-original-price">市场价</p> -->
              <p class="row-goods-price">¥ {{ item.shop_price }}</p>
            </div>
          </div>
        </div>

      </van-list>
    </div>

    <van-empty class="custom-image" v-if="productList.length < 1" image="https://qiniu.zdyxjx.com/v3/pic/df86163273fa44d7bd9bd03a5942c67e.png" />

    <div class="car-foot-block" v-if="productList.length > 0  && isEdit == false ">
      <van-checkbox style="margin-right:5px;" v-model="checkAll">全选</van-checkbox>
      <div class="car-foot-btn btnC" @click="deleteGoods">删除产品</div>
    </div>

  </div>
</template>

<script type="text/babel">
export default {
  name: "MainFootPrint",
  components: {},
  props: {},
  data() {
    return {
      isEdit: true, // 是否编辑
      checkAll: false,
      active: -1,
      radio_icon: require('../../assets/icon/radio.png'), //radio
      radio_active_icon: require('../../assets/icon/radio-active.png'), //radio active
      pageNum: 1,
      pageSize: 10,
      loading: true,
      finished: false,
      //商品
      productList: [
        // {
        //   productId: "12131",
        //   name: "乐扣乐扣-莹彩蓝轻量保温杯",
        //   pic: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
        //   description: "乐扣乐扣-莹彩蓝轻量保温杯",
        //   showPrice: 100.0,
        //   salePrice: 0.0,
        //   costPrice: 100.0,
        //   status: 1,
        //   checked: false,
        // },
      ],
    };
  },
  watch: {
    checkAll: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
        if (newValue) {
          this.productList.map((item, index) => {
            item.checked = true;
          });
        } else {
          this.productList.map((item, index) => {
            item.checked = false;
          });
        }
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    // this.$toast.loading();

    // setTimeout(() => {
    //   this.$toast.clear();
    // }, 300);

    this.getInit();
  },
  methods: {
    //
    getInit() {
      let _this = this;
      this.$toast.loading();
      let data = {
        // status: 1, // 1 降价  2失效
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/footprint_list", data, data).then((res) => {
        console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);

          let lists = res.data.data;

          if (lists && lists.length > 0) {
            lists = lists.map((item, index) => {
              var adata = [];
              adata = item.goods.map((itm, inx) => {
                return Object.assign({}, itm, { checked: false });
              });
              return {
                date: item.date,
                goods: adata,
              };
            });

            console.log(lists);

            if (_this.pageNum == 1) {
              _this.productList = [];
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
          _this.$toast.clear();
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    setType(ind, e) {
      // this.productList[ind].checked = true;
      console.log(e);
      if (this.isEdit == false) {
        e.checked = !e.checked;
        console.log(this.productList);
        // } else if (this.isEdit && e.status != 1) {
        //   this.$toast.fail("商品已下架~");
      } else {
        this.$router.push({ path: `/product-details/${e.id}` });
      }
    },
    // 删除
    deleteGoods() {
      this.$toast("删除");
      let listss = [];
      this.productList.map((itm, inmx) => {
        itm.goods.map((item, index) => {
          if (item.checked == false) {
            listss.push(item);
          }
          // this.productList = listss;
          // console.log(this.productList);
        });

        // if (item.checked == false) {
        //   listss.push(item);
        // }
        // this.productList = listss;
        // console.log(this.productList);
      });
      console.log(listss);
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 编辑
    onClickRight() {
      this.isEdit = !this.isEdit;
      this.$toast("编辑");
    },
  },
};
</script>
<style lang="scss">
.foot-print-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>

<style lang="scss" scoped>
.foot-print-page {
  // height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
  // 横向

  .time-tips {
    text-align: left;
    padding: 5px 10px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 600;
  }
  .img-text-row {
    width: 100%;
    height: 125px;
    background-color: #fff;
    //  background-color: palegoldenrod;
    margin-bottom: 10px;
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .radio {
      width: 18px;
      height: 18px;
      //   background-color: #eee;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .row-goods-img {
      width: 115px;
      height: 115px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .row-goods-info {
      width: 190px;
      height: 100%;
      padding: 5px 0;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      //  background-color: paleturquoise;

      .row-goods-leble {
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 17px;
        color: #ffffff;
        letter-spacing: 1px;
        text-align: left;

        span {
          padding: 1px 7px;
          border-radius: 3px;
        }

        .rx {
          background-color: #e95970;
        }
        .xs {
          margin-left: 3px;
          background-color: #b80009;
        }
      }
      .row-goods-name {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 30px;
        color: #333333;
        letter-spacing: 1px;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .row-goods-des {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 20px;
        color: #78849e;
        letter-spacing: 1px;
        display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        overflow: hidden; /*超出的文本隐藏*/
        text-overflow: ellipsis; /* 溢出用省略号*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .row-goods-class {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 20px;
        color: #78849e;
        letter-spacing: 1px;
      }
      .row-goods-original-price {
        text-decoration: line-through;
        font-size: 10px;
        margin-top: 10px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 17px;
        color: #cccccc;
      }
      .row-goods-price {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 30px;
        color: #ff5000;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 10px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 17px;
          color: #cccccc;
        }
      }
    }
  }
}
// //底部
.car-foot-block {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 50px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px -2px 5px rgba(120, 132, 158, 0.16);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;

  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #2a2e43;
  .car-foot-btn {
    width: 173px;
    height: 40px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 21px;
    color: #ffffff;
    background: #ff5000;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.btnC:active {
  background-color: rgba(255, 80, 0, 0.7) !important;
}
</style>

